export default function useScrollToError(errors) {
	const errorsvalues = Object.values(errors);
	const firstError = errorsvalues[0]?.ref?.name;
	const firstElement = document.querySelector(`[name="${firstError}"]`);

	if (firstElement) {
		firstElement.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
	}
}
